export function getImageSize(base64String: string) {
  // Remove Base64 metadata prefix
  const base64Image = base64String.split(",")[1];

  // Calculate the padding characters
  const paddingCharacters = (base64Image.match(/=+$/) || [""])[0].length;

  // Calculate the base64 length
  const base64Length = base64Image.length;

  // Calculate the size in bytes
  const sizeInBytes = (base64Length * 3) / 4 - paddingCharacters;

  return sizeInBytes;
}
